//export const serverUrl = "https://localhost:44386/";
export const serverUrl = "/";
